<div class="flex items-center justify-center">
  <div
    class="relative w-full lg:bg-white rounded-[32px] shrink-0! lg:shadow-lg overflow-hidden flex items-center lg:p-4 gap-4"
  >
    <div
      class="flex justify-center items-center"
      [ngClass]="{ 'h-40 w-30': mobile, 'h-45 w-40': !mobile }"
    >
      <img
        class="bg-contain bg-center bg-no-repeat shrink-0! rounded-[32px]"
        [src]="`../../../../assets/img/PNGs/${product?.Code}.png`"
        [alt]="product?.Description"
      />
    </div>

    <div class="flex flex-col gap-1 lg:gap-4">
      <div class="w-full lg:w-50 flex flex-col gap-1">
        <div
          class="leading-tight"
          [ngClass]="{ 'text-general': !mobile, 'text-general-subtitle w-60': mobile }"
        >
          {{ product?.Description }}
        </div>
        <p
          class="text-[#e3001b] text-2xl font-black"
          [ngClass]="{ 'text-xl': mobile, 'text-2xl': !mobile }"
        >
          {{ product?.Cost | currency: 'USD' : 'symbol' : '1.2-2' }}
        </p>
      </div>
      <div class="w-full lg:w-50 flex flex-col gap-1">
        <div class="text-general leading-tight">Cantidad</div>
        <div
          class="w-fit min-w-28 flex items-center justify-between rounded-full border-2 text-(--color-text-primary)! px-2 py-1"
        >
          <button
            type="button"
            class="w-6 flex items-center justify-center rounded-full"
            (click)="removeProduct()"
          >
            <mat-icon>{{ (product?.amount ?? 0) > 1 ? 'remove' : 'delete' }}</mat-icon>
          </button>

          <span class="text-general">{{ product?.amount || 0 }}</span>

          <button
            type="button"
            aria-label="Aumentar cantidad"
            class="w-6 flex items-center justify-center rounded-full"
            (click)="addProduct()"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
